<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 16 16">
    <g transform="translate(3634 10472)">
      <path d="M5,6.618a.674.674,0,1,0,.953.953L8.845,4.678l2.894,2.894a.674.674,0,0,0,.953-.953L9.322,3.247a.674.674,0,0,0-.953,0Zm7.7,6.2a.674.674,0,0,0-.953-.953L8.845,14.756,5.951,11.862A.674.674,0,1,0,5,12.815l3.371,3.371a.674.674,0,0,0,.953,0Z" transform="translate(-3634.845 -10473.717)" fill="#495057" fill-rule="evenodd"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSort',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>